export default {
	STANDARDGAMES: 'standardgames',
	BAKERGAMES: 'bakergames'
}


// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/Setup/fields.js